import { Link } from "react-router-dom";
import { Header } from "@/components/site/Header";
import { Footer } from "@/components/site/Footer";
import { Seo } from "@/components/seo/Seo";

export const NotFound = () => (
  <>
    <Seo title="Page not found" path="/404" noindex />
    <Header />
    <main className="max-w-2xl mx-auto px-6 pt-32 pb-32 text-center" data-testid="not-found">
      <div className="text-[11px] tracking-[0.3em] uppercase text-neutral-500 mb-3 font-medium">404</div>
      <h1 className="font-heading text-5xl md:text-6xl tracking-tight leading-[1.02] mb-5">
        <span className="font-black">Nothing here.</span>
      </h1>
      <p className="text-base text-neutral-600 font-light mb-8">
        The page you were looking for doesn&apos;t exist or has moved.
      </p>
      <div className="flex justify-center gap-3">
        <Link to="/" className="inline-flex items-center justify-center h-11 px-6 bg-black text-white text-sm font-medium hover:bg-neutral-800">
          Back to home
        </Link>
        <Link to="/journal" className="inline-flex items-center justify-center h-11 px-6 border border-black text-sm font-medium hover:bg-black hover:text-white">
          Browse journal
        </Link>
      </div>
    </main>
    <Footer />
  </>
);
